// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__iKSBj","list":"PatternAutocomplete_list__3dUYm"};